export default __webpack_public_path__ + "static/media/cards_flips_1.c6b2156a.mp3";